import { applyConsoleDebugPolicy } from './utils/consoleDebug';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import reportWebVitals from './reportWebVitals';
import { CompanyProvider } from './CompanyProvider';
import { LoadingProvider } from './LoadingContext';
import { getSession, getSessionJSON, setSession } from './utils/SessionUtils';

applyConsoleDebugPolicy();

function AppInitializer({ children }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const context = getSessionJSON("CONTEXTS");
    if (context?.length && !getSession("COMPANY")) {
      setSession("COMPANY", context[0].companyCode);
    } else if (!getSession("COMPANY") && process.env.REACT_APP_COMPANY) {
      setSession("COMPANY", process.env.REACT_APP_COMPANY);
    }
    setReady(true);
  }, []);
  if (!ready) return <div>Loading...</div>; // Or a spinner

  return children;
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppInitializer>
        <CompanyProvider>
          <LoadingProvider>
            <App />
          </LoadingProvider>
        </CompanyProvider>
      </AppInitializer>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
